import { Component, inject } from '@angular/core';
import { AutocompleteComponent } from '@shared/components/autocomplete';
import {
  DynamicPhoneValidationDirective,
  PhoneNumberMaskDirective,
} from '@shared/directives';
import { ButtonComponent } from '@shared/components/button';
import { RegisterTrustFormService } from './register-trust-form.service';
import { ReactiveFormsModule } from '@angular/forms';
import { UserSearchStateService } from '../../shared/services/user-search-state.service';
import {
  HandleAutocompleteOptionClickDirective,
  HandleUserSearchDirective,
} from '../../shared/directives';
import { FormMessageComponent } from '@shared/components/forms';
import { getOptionsFromEnums, getPhonePrefixOptions } from '@shared/utils';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { DYNAMIC_PHONE_DIRECTIVE_CONFIG } from '../../shared/constants/dynamic-phone-directive-config.constants';
import { CloseApplicationModalDirective } from '../../shared/directives/close-modal.directive';
import { ClerkCreateTrustFacadeService } from './clerk-create-trust-facade.service';
import { CcsInputComponent, CcsSelectComponent } from '@shared/components';
import { CREATE_APPLICATION_TRUST_ERROR_MESSAGES } from './constants';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  TrustRequestedActionsEnum,
  TrustRequestedActionsLabels,
} from '@app/trust/features/dashboard/shared/enums';
import { HandleClerkCreateTrustSubmitDirective } from './directives/handle-clerk-create-trust-submit.directive';

@Component({
  selector: 'app-clerk-create-trust-form',
  templateUrl: 'clerk-create-trust-form.component.html',
  imports: [
    AutocompleteComponent,
    DynamicPhoneValidationDirective,
    ButtonComponent,
    ReactiveFormsModule,
    HandleUserSearchDirective,
    HandleAutocompleteOptionClickDirective,
    FormMessageComponent,
    DynamicPhoneValidationDirective,
    CloseApplicationModalDirective,
    HandleClerkCreateTrustSubmitDirective,
    PhoneNumberMaskDirective,
    CcsSelectComponent,
    CcsInputComponent,
    MatSlideToggleModule,
  ],
  providers: [RegisterTrustFormService, ClerkCreateTrustFacadeService],
})
export class ClerkCreateTrustFormComponent {
  private readonly _formService = inject(RegisterTrustFormService);

  protected readonly form = this._formService.form;

  private readonly _userSearchStateService = inject(UserSearchStateService);

  protected readonly isLoading = this._userSearchStateService.isLoading;

  protected readonly phonePrefixOptions = getPhonePrefixOptions();
  protected readonly ERROR_MESSAGES = CREATE_APPLICATION_TRUST_ERROR_MESSAGES;

  protected formattedUsersByName =
    this._userSearchStateService.formattedSearchedUsersByName;
  protected formattedUsersByEmail =
    this._userSearchStateService.formattedSearchedUsersByEmail;

  protected get isPhonePrefixUS() {
    return this.form.controls.prefixPhone.value === DEFAULT_USA_PHONE_PREFIX;
  }

  protected readonly dynamicPhoneDirectiveConfig =
    DYNAMIC_PHONE_DIRECTIVE_CONFIG;

  protected readonly isFirm = this._formService.isFirm;

  protected readonly requestedActionsOptions = getOptionsFromEnums(
    TrustRequestedActionsEnum,
    TrustRequestedActionsLabels,
  );
}
